import { EUserRole } from 'shared/types';

export const checkRolePermission = (
  permissibleRoles: EUserRole[],
  currentUserRole: EUserRole
): boolean => permissibleRoles.some((item): boolean => item === currentUserRole);
